
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trucking-companies",
      function () {
        return require("private-next-pages/trucking-companies/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/trucking-companies"])
      });
    }
  